import * as routeActions from 'actions/routeActions'
import * as userActions from 'actions/userActions'

import idx from 'idx'
import { compose, withHandlers } from 'recompose'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

export default compose(
  connect(
    (state) => {
      return {
        organisation: idx(state, _ => _.organisation.selected)
      }
    },
    (dispatch) => {
      const actions = {
        ...routeActions,
        ...userActions,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  // Handlers
  withHandlers({
    goTo: props => (route) => {
      if (route !== props.location) {
        props.actions.redirect(route)
      }
    },
    onLogout: props => () => {
      props.actions.logoutUser()
    },
  }),
)



// WEBPACK FOOTER //
// ./src/containers/core/AppHeader/AppHeader.enhancer.js